import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TableSortArrow } from '../../../../utils/IconComp';
import { EyeIcon } from '../../../../utils/SVGIcon';
import { GetDate } from '../../../../utils/Show';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';
import sortData from '../../../../utils/sortData';

function TableRow({ data }) {
    const navigate = useNavigate();

    const handleView = (id) => {
        navigate(mkRelativeUrl(`/billing/invoices/${id}/info`));
    };

    if (data && !data?.length) {
        return (
            <tr className="hover:!bg-inherit">
                <td colSpan={9} className="!text-left">
                    No Pending Subscription Found!
                </td>
            </tr>
        );
    }

    return data?.map((item) => (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.invoiceId}</span>
            </td>
            <td onClick={() => handleView(item?.invoiceId)}>
                <span className="group-hover:text-secondary group-hover:font-medium cursor-pointer hover:underline text-ellipsis block w-full overflow-hidden">
                    {item?.subscriptionName}
                </span>
                <span className="text-secondary text-xs lowercase overflow-hidden text-ellipsis block w-full ">
                    {item?.domain}
                </span>
            </td>
            <td
                onClick={() => navigate(mkRelativeUrl(`/customers/${item?.userId}/info`))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                <span className="group-hover:font-medium text-ellipsis block w-full overflow-hidden">
                    {item?.customerInfo?.organization || '-----'}
                </span>
            </td>
            <td>
                <span className="text-ellipsis block w-full overflow-hidden">
                    {item?.customerInfo?.primaryEmail || '----'}
                </span>
            </td>
            <td className="">
                <span>
                    {item?.limitBy}
                    {/* {
                        limitBy.find((itemThis) => itemThis.key === item?.limitBy?.toLowerCase())
                            ?.value
                    } */}
                </span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeFirstInstallation) || 'No Installation Date'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeSubscriptionStart) || 'No Start Date'}</span>
            </td>
            <td className={`text-center ${item?.expireSoon ? '!text-error *:font-medium' : ''}`}>
                <span>{GetDate(item?.timeSubscriptionEnd) || 'No End Date'}</span>
            </td>
            <td className="text-center capitalize">
                <span className={item?.status === 'active' ? 'text-secondary' : 'text-warning'}>
                    {item?.status}
                </span>
            </td>
            <td className="text-center">
                <span>
                    <button
                        type="button"
                        onClick={() => handleView(item?.invoiceId)}
                        // data-tooltip-id="myToolTip"
                        // data-tooltip-content="View"
                        className="size-[32px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    ));
}
function TableHeader({ sortedHandler, sortedColumn, sortBy }) {
    return (
        <thead>
            <tr>
                <th scope="col" onClick={() => sortedHandler('id')}>
                    <span className="">ID</span>
                    <TableSortArrow name="id" sortBy={sortBy} sortedColumn={sortedColumn} />
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Subscription</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Customer Info.</span>
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Email</span>
                </th>
                <th scope="col" className="w-32 !cursor-default">
                    <span>Limit By</span>
                </th>
                <th
                    scope="col"
                    className="w-36 text-center"
                    onClick={() => sortedHandler('installation-date')}
                >
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Date of Installation">
                        Inst. Date
                    </span>
                    <TableSortArrow
                        name="installation-date"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    scope="col"
                    className="w-30 text-center"
                    onClick={() => sortedHandler('subscription-start')}
                >
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Subscription Start"
                    >
                        Subs. Start
                    </span>
                    <TableSortArrow
                        name="subscription-start"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th
                    scope="col"
                    className="w-30 text-center"
                    onClick={() => sortedHandler('subscription-end')}
                >
                    <span
                        data-tooltip-id="tblTooltip"
                        data-tooltip-content="Date of Subscription End"
                    >
                        Subs. End
                    </span>
                    <TableSortArrow
                        name="subscription-end"
                        sortBy={sortBy}
                        sortedColumn={sortedColumn}
                    />
                </th>
                <th scope="col" className="w-30 text-center">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Subscription Status">
                        Subs. Status
                    </span>
                </th>
                <th scope="col" className="!cursor-default">
                    #
                </th>
            </tr>
        </thead>
    );
}

function PendingSubscriptionTable({ data, sortedHandler, sortedColumn, sortBy }) {
    const isAsc = sortBy === 'asc';

    let column = '';
    if (sortedColumn === 'id') {
        column = 'invoiceId';
    }
    if (sortedColumn === 'installation-date') {
        column = 'timeClientInstallation';
    }
    if (sortedColumn === 'subscription-start') {
        column = 'timeSubscriptionStart';
    }
    if (sortedColumn === 'subscription-end') {
        column = 'timeSubscriptionEnd';
    }

    const arr = sortData(data?.subscriptions, column, isAsc);

    return (
        <div className="subscriptions_page_table mb-40">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    sortedHandler={sortedHandler}
                    sortBy={sortBy}
                    sortedColumn={sortedColumn}
                />
                <tbody>
                    <TableRow data={arr} />
                </tbody>
            </table>
        </div>
    );
}

export default PendingSubscriptionTable;
